module.exports = __webpack_public_path__ + "static/scale-model-of-rose-district-fountain-in-broken-arrow-oklahoma-67f29bf7ad8a30877202269a715df5b9.png";